import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { InfoOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, InfoPill, Stack, Tooltip, Typography } from '@lyearn/ui';

import SpecificRolesList from '../SpecificRolesList';

export interface SpecificRolesProps {
  className?: string;
  staffRoleIds?: string[] | null;
  contentName: string;
  onChange: (val: string[]) => void;
}

function SpecificRoles(props: SpecificRolesProps) {
  const { t } = useTranslation();
  const { className, contentName, onChange } = props;
  const staffRoleIds = props.staffRoleIds || [];

  return (
    <Stack className={cn(className, 'w-full')} direction="col">
      <Stack alignItems="center" className="mb-4 w-full px-8" justifyContent="between">
        <Stack alignItems="center">
          <Typography color="text-text-primary" variant="label-01">
            {t('AssignmentRestriction:AssignableBy')}
          </Typography>
          <Tooltip placement="right" title={t('AssignmentRestriction:InfoTooltip')!}>
            <Box className="ms-4">
              <InfoOutline className="h-18 w-18" fillColorToken="icon-secondary" />
            </Box>
          </Tooltip>
        </Stack>
        <InfoPill
          appearance="secondary"
          label={t('Common:Departments.Role', { count: staffRoleIds.length })}
          type="text"
        />
      </Stack>
      <SpecificRolesList
        contentName={contentName}
        staffRoleIds={staffRoleIds}
        onChange={onChange}
      />
    </Stack>
  );
}

export default SpecificRoles;
